import { jsx as _jsx } from "react/jsx-runtime";
import { createRichTextEntityNode, RichTextNodeType, } from '@dossierhq/core';
import { BlockWithAlignableContents } from '@lexical/react/LexicalBlockWithAlignableContents.js';
import { DecoratorBlockNode } from '@lexical/react/LexicalDecoratorBlockNode.js';
import { createCommand, } from 'lexical';
import { ReferenceFieldEditorWithoutClear } from '../EntityEditor/ReferenceFieldEditor.js';
export function $createAdminEntityNode(reference) {
    return new AdminEntityNode(reference);
}
/** @public */
export function $isAdminEntityNode(node) {
    return node instanceof AdminEntityNode;
}
export const INSERT_ADMIN_ENTITY_COMMAND = createCommand();
function AdminEntityComponent({ className, format, nodeKey, reference, }) {
    return (_jsx(BlockWithAlignableContents, { className: className, format: format, nodeKey: nodeKey, children: _jsx(ReferenceFieldEditorWithoutClear, { className: "rich-text-item-indentation", value: reference }) }));
}
export class AdminEntityNode extends DecoratorBlockNode {
    __reference;
    static getType() {
        return RichTextNodeType.entity;
    }
    static clone(node) {
        return new AdminEntityNode(node.__reference, node.__format, node.__key);
    }
    constructor(reference, format, key) {
        super(format, key);
        this.__reference = reference;
    }
    setReference(reference) {
        const self = this.getWritable();
        self.__reference = reference;
    }
    getReference() {
        const self = this.getLatest();
        return self.__reference;
    }
    static importJSON(serializedNode) {
        const node = $createAdminEntityNode(serializedNode.reference);
        node.setFormat(serializedNode.format);
        return node;
    }
    exportJSON() {
        //TODO format
        return createRichTextEntityNode(this.__reference);
    }
    createDOM() {
        const div = document.createElement('div');
        div.style.display = 'contents';
        return div;
    }
    getTextContent() {
        return '\n';
    }
    decorate(_editor, config) {
        const embedBlockTheme = config.theme.embedBlock || {};
        const className = {
            base: embedBlockTheme.base || '',
            focus: embedBlockTheme.focus || '',
        };
        return (_jsx(AdminEntityComponent, { className: className, reference: this.__reference, format: this.__format, nodeKey: this.__key }));
    }
}
//# sourceMappingURL=AdminEntityNode.js.map